module.exports = __webpack_public_path__ + "static/media/ilustracao_nao_autorizado.c048fcf6.svg";